

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const UPDATEKRAKPI= createAsyncThunk(
  "updateKraKpi/updateKraKpi",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateKraKpiSlice = createSlice({
  name: "updateKraKpiSlice",
  initialState: {
    updateKraKpi: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateKraKpi: (state) => {
        state.updateKraKpi.loading = false
        state.updateKraKpi.error = false
        state.updateKraKpi.data = []
        state.updateKraKpi.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATEKRAKPI.fulfilled, (state, action) => {
      state.updateKraKpi = {
        ...state.updateKraKpi,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEKRAKPI.pending, (state, action) => {
      state.updateKraKpi = {
        ...state.updateKraKpi,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEKRAKPI.rejected, (state, action) => {
      state.updateKraKpi = {
        ...state.updateKraKpi,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateKraKpiAction = {
    UPDATEKRAKPI,
};

export { updateKraKpiAction };
export default updateKraKpiSlice.reducer;
export const {setInitialStateOfupdateKraKpi} = updateKraKpiSlice.actions
